export default {
  CREATE_ADS: "CREATE_ADS",
};
